import { Component, OnInit, AfterViewInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { TabsetComponent } from 'ngx-bootstrap/tabs';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-transferringassessedvalue',
    templateUrl: './transferringassessedvalue.component.html',
    styleUrls: ['./transferringassessedvalue.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TransferringassessedvalueComponent implements OnInit, AfterViewInit {

  @ViewChild('staticTabs', { static: false }) staticTabs: TabsetComponent;
  id: number;
  selectTab(tabId: number) {
    this.staticTabs.tabs[tabId].active = true;
  }
  constructor(private actRoute: ActivatedRoute) {
    this.id = this.actRoute.snapshot.params.id;
  }
  ngAfterViewInit() {
    console.log(this.id);
    this.selectTab(this.id - 1);
  }

  ngOnInit() {

  }


}
